export const BILL_REFERENCE = 'Bill_Reference';
export const ACCOUNT_INSURANCE = 'Account_Insurance';
export const ACCOUNT_FINANCIALS = 'Account_Financials';
